import { Theme } from '@mui/material/styles';

import { BrandSemanticTokens, cssBrandTokens } from './brands/brandTokens';

export const getBrandTokens = (theme: Theme): BrandSemanticTokens =>
  theme.custom.brandTokens ?? cssBrandTokens;
